import { initializeApp } from 'firebase/app';

import {getAnalytics, logEvent, setUserProperties} from "firebase/analytics";
import OrgApi from '../api/org';
import AnalyticsApi from '../api/analytics';
import { CUSTOM_THEME } from '../constants/themeConstants';
import firebaseConfig from './firebaseConfig';

let firebaseApp;
let analytics;

export const initializeFirebase = (appId, env) => {
  try {
    const firebaseAppConfig =
      appId === 'engage4' ? firebaseConfig : CUSTOM_THEME[appId].firebaseConfig[env].default;
      firebaseApp = initializeApp(firebaseAppConfig);
      analytics = getAnalytics(firebaseApp);
  } catch (err) {
    console.log(JSON.stringify(err));
  }
};

export const logFirebaseEvent = async ({ event, action = '', attachment = '' }) => {
  try {
    const orgResp = await OrgApi.fetchOrgName();

    if (action) {
      logEvent(analytics, event, {
        action,
        attachment,
      });

      if (orgResp && orgResp.shouldCallAnalyticsAPIForThisOrganisation) {
        AnalyticsApi.logEvent({
          event_name: event,
          event_action: action
        })
      }
    } else {
      logEvent(analytics, event);

      if (orgResp && orgResp.shouldCallAnalyticsAPIForThisOrganisation) {
        AnalyticsApi.logEvent({
          event_name: event
        })
      }
    }
  } catch (err) {
    console.log(JSON.stringify(err));
  }
};

export const logFirebaseUserProperty = async () => {
  try {
    const orgResp = await OrgApi.fetchOrgName();
    if (orgResp && orgResp.org_name) {
      setUserProperties(analytics, {'Org_Name': orgResp.org_name});

      if (orgResp.shouldCallAnalyticsAPIForThisOrganisation) {
        AnalyticsApi.logUserProperty(orgResp.org_name)
      }
    }
  } catch (err) {
    console.log(JSON.stringify(err));
  }
};
